import React, { useEffect, useRef, useState } from 'react';
import { Steps, Tooltip } from 'antd';
import { omit } from 'lodash';

import emitter, { EventTypes } from 'APP_ROOT/utils/eventEmitter';

import TitleStyled from '../styled/tabs';

const Step = Steps.Step;

const setTab = tab => e => emitter.emit(EventTypes.SET_TAB, tab);
const getValidProps = props =>
  omit(props, [
    'dataEnums',
    'dataKey',
    'index',
    'isFirst',
    'isLast',
    'onClick',
    'onSubmit',
    'overrides',
    'presentation',
    'properties',
    'settings',
    'tab',
    'title',
    'validations',
    'wrappedComponentRef',
    'isReviewer',
    'templates',
    'timezone',
    'tabsRefs',
    'formHeader',
    'options',
    'nodeId',
    'storeSubscription',
    'reportingKey',
  ]);

const TitleWithTooltip = ({ title }) => {
  const titleRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) {
      setShowTooltip(false);
      return;
    }

    // Small delay to make sure the DOM is completely rendered
    // before measuring the element's dimensions. This helps ensure
    // accurate tooltip display.
    const timeoutId = window.setTimeout(() => {
      const isOverflowing =
        el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
      setShowTooltip(isOverflowing);
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [title]);

  return showTooltip ? (
    <Tooltip title={title} mouseEnterDelay={0.5} data-testid="tab-title-tooltip">
      <TitleStyled innerRef={titleRef} data-testid="tab-title">
        {title}
      </TitleStyled>
    </Tooltip>
  ) : (
    <TitleStyled innerRef={titleRef} data-testid="tab-title">
      {title}
    </TitleStyled>
  );
};

const Tab = props => {
  const { index = '', title = '' } = props;

  const tabProps = getValidProps(props);
  const titleContent =
    typeof title === 'string' ? <TitleWithTooltip title={title} /> : title;

  return (
    <Step
      key={index}
      title={titleContent}
      onClick={setTab(index)}
      {...tabProps}
    />
  );
};

export default Tab;
